import { useBreakpointValue } from '@chakra-ui/react';
import { useContext } from 'react';

import { IsMobileContext } from '$/contexts/IsMobileContext';
import { isSmartphone } from '$/utils/userAgent';

export const useIsMobile = (
  {
    sm,
    forceSmartphoneIsMobile,
  }: { sm: boolean; forceSmartphoneIsMobile?: boolean } = { sm: false },
) => {
  const containerIsMobile = useContext(IsMobileContext);
  const breakpointIsMobile = !!useBreakpointValue(
    { base: true, mobile: sm, sm: false },
    { ssr: false },
  );

  if (containerIsMobile !== undefined) return containerIsMobile;

  const isMobile =
    forceSmartphoneIsMobile === true ? isSmartphone() : breakpointIsMobile;

  return isMobile;
};
